import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs, isDefined } from '@togglecorp/fujs';
import useDebouncingTextChange from '../../hooks/useDebouncingTextChange.js';
import useUiModeClassName from '../../hooks/useUiModeClassName.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

/**
 * The most basic input component with default stylings removed (without any styling)
 */
function RawInput(_ref) {
  let {
    className,
    onChange,
    uiMode,
    elementRef,
    value,
    name,
    autoComplete = 'off',
    ...otherProps
  } = _ref;
  const {
    value: immediateValue,
    onInputChange: handleInputChange,
    onInputBlur: handleInputBlur
  } = useDebouncingTextChange({
    name,
    value,
    onChange
  });
  const themeClassName = useUiModeClassName(uiMode, styles.light, styles.dark);
  return /*#__PURE__*/React.createElement("input", _extends({
    ref: elementRef,
    className: _cs(className, styles.rawInput, themeClassName),
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    value: immediateValue ?? '',
    name: isDefined(name) ? String(name) : undefined,
    autoComplete: autoComplete // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps));
}

var RawInput$1 = genericMemo(RawInput);

export { RawInput$1 as default };
//# sourceMappingURL=index.js.map
